import { ROUND, ROUNDUP } from './Formatters';
import { InputValue } from './data';

export class AdministrativeCostsData {
  storagehourly = 106.71; //?;

  nbrAdmins!: number;
  tickets!: number;
  annualTickets!: number;
  avgTimeTickets!: number;
  salary!: number;
  burdenedRate!: number;

  ticketElimination = 0;
  avoidedTickets!: number;
  TicketResolution = 0;
  avgTimeCloseTickets!: number;

  IThrsYear!: number;
  costPerTicketYear!: number;

  ticketEliminationIBM = 85;
  avoidedTicketsIBM!: number;
  TicketResolutionIBM = 25;
  avgTimeCloseTicketsIBM!: number;

  IThrsYearIBM!: number;
  costPerTicketYearIBM!: number;

  maxFTEhrsYear!: number;
  pctFTEtime!: number;
  IThrsAvailable!: number;

  pct_planningEval!: number;
  pct_monitoring!: number;
  pct_applicationOptimization!: number;
  pct_securityEomp!: number;
  pct_userAccess!: number;
  pct_dataProtection!: number;
  pct_newInstalls!: number;

  pct_planningEvalIBM = 95;
  pct_monitoringIBM = 90;
  pct_applicationOptimizationIBM = 95;
  pct_securityEompIBM = 80;
  pct_userAccessIBM = 50;
  pct_dataProtectionIBM = 80;
  pct_newInstallsIBM = 90;

  hours_planningEval!: number;
  hours_monitoring!: number;
  hours_applicationOptimization!: number;
  hours_SecurityComp!: number;
  hours_userAccess!: number;
  hours_dataProtection!: number;
  hours_newInstalls!: number;
  totalFTEManHours!: number;
  pct_totalFTEManHours!: number;

  hours_planningEvalIBM!: number;
  hours_monitoringIBM!: number;
  hours_applicationOptimizationIBM!: number;
  hours_SecurityCompIBM!: number;
  hours_userAccessIBM!: number;
  hours_dataProtectionIBM!: number;
  hours_newInstallsIBM!: number;
  totalFTEManHoursIBM!: number;
  pct_totalFTEManHoursIBM!: number;

  costsSuppTickets!: number;
  costsPlanningEval!: number;
  costsMonitoring!: number;
  costsAppOptimization!: number;
  costsSecurityCompliance!: number;
  costsUserAccess!: number;
  costsDataProtection!: number;
  costsNewInstalls!: number;
  totalAdminCosts!: number;

  costsSuppTicketsIBM!: number;
  costsPlanningEvalIBM!: number;
  costsMonitoringIBM!: number;
  costsAppOptimizationIBM!: number;
  costsSecurityComplianceIBM!: number;
  costsUserAccessIBM!: number;
  costsDataProtectionIBM!: number;
  costsNewInstallsIBM!: number;
  totalAdminCostsIBM!: number;

  totalAdminSavings!: number;
  totalAdminPCT!: number;

  public Calculate = (inputValue: InputValue) => {
    this.pct_planningEval = inputValue.pct_planningEval;
    this.pct_monitoring = inputValue.pct_monitoring;
    this.pct_applicationOptimization = inputValue.pct_applicationOptimization;
    this.pct_securityEomp = inputValue.pct_securityEomp;
    this.pct_userAccess = inputValue.pct_userAccess;
    this.pct_dataProtection = inputValue.pct_dataProtection;
    this.pct_newInstalls = inputValue.pct_newInstalls;

    this.annualTickets = inputValue.tickets * 12;
    this.avgTimeTickets = inputValue.timeTickets / 60;
    this.burdenedRate = (inputValue.salary / 2080) * (1 + 36 / 100);
    this.storagehourly = ROUNDUP(this.burdenedRate, 2);

    this.avoidedTickets =
      inputValue.timeTickets * (this.ticketElimination / 100);
    this.avgTimeCloseTickets = this.avgTimeTickets;

    this.avoidedTicketsIBM =
      this.annualTickets * (this.ticketEliminationIBM / 100);
    this.avgTimeCloseTicketsIBM =
      this.avgTimeTickets * (1 - this.TicketResolutionIBM / 100);

    this.IThrsYear =
      (this.annualTickets - this.avoidedTickets) * this.avgTimeCloseTickets;
    this.costPerTicketYear = this.IThrsYear * this.storagehourly;

    this.IThrsYearIBM =
      (this.annualTickets - this.avoidedTicketsIBM) *
      this.avgTimeCloseTicketsIBM;
    this.costPerTicketYearIBM = this.IThrsYearIBM * this.storagehourly;

    this.maxFTEhrsYear = inputValue.nbrAdmins * 40 * 48;
    this.IThrsAvailable =
      (this.maxFTEhrsYear * inputValue.pctFTEtime) / 100 - this.IThrsYear;

    this.hours_planningEval =
      (this.IThrsAvailable * this.pct_planningEval) / 100;
    this.hours_monitoring = (this.IThrsAvailable * this.pct_monitoring) / 100;
    this.hours_applicationOptimization =
      (this.IThrsAvailable * this.pct_applicationOptimization) / 100;
    this.hours_SecurityComp =
      (this.IThrsAvailable * this.pct_securityEomp) / 100;
    this.hours_userAccess = (this.IThrsAvailable * this.pct_userAccess) / 100;
    this.hours_dataProtection =
      (this.IThrsAvailable * this.pct_dataProtection) / 100;
    this.hours_newInstalls = (this.IThrsAvailable * this.pct_newInstalls) / 100;
    this.totalFTEManHours =
      this.hours_planningEval +
      this.hours_monitoring +
      this.hours_applicationOptimization +
      this.hours_SecurityComp +
      this.hours_userAccess +
      this.hours_dataProtection +
      this.hours_newInstalls;
    this.pct_totalFTEManHours = 0;

    this.hours_planningEvalIBM =
      this.hours_planningEval * (1 - this.pct_planningEvalIBM / 100);
    this.hours_monitoringIBM =
      this.hours_monitoring * (1 - this.pct_monitoringIBM / 100);
    this.hours_applicationOptimizationIBM =
      this.hours_applicationOptimization *
      (1 - this.pct_applicationOptimizationIBM / 100);
    this.hours_SecurityCompIBM =
      this.hours_SecurityComp * (1 - this.pct_securityEompIBM / 100);
    this.hours_userAccessIBM =
      this.hours_userAccess * (1 - this.pct_userAccessIBM / 100);
    this.hours_dataProtectionIBM =
      this.hours_dataProtection * (1 - this.pct_dataProtectionIBM / 100);
    this.hours_newInstallsIBM =
      this.hours_newInstalls * (1 - this.pct_newInstallsIBM / 100);
    this.totalFTEManHoursIBM =
      this.hours_planningEvalIBM +
      this.hours_monitoringIBM +
      this.hours_applicationOptimizationIBM +
      this.hours_SecurityCompIBM +
      this.hours_userAccessIBM +
      this.hours_dataProtectionIBM +
      this.hours_newInstallsIBM;

    this.costsSuppTickets = this.costPerTicketYear;
    this.costsPlanningEval = this.hours_planningEval * this.storagehourly;
    this.costsMonitoring = this.hours_monitoring * this.storagehourly;
    this.costsAppOptimization =
      this.hours_applicationOptimization * this.storagehourly;
    this.costsSecurityCompliance = this.hours_SecurityComp * this.storagehourly;
    this.costsUserAccess = this.hours_userAccess * this.storagehourly;
    this.costsDataProtection = this.hours_dataProtection * this.storagehourly;
    this.costsNewInstalls = this.hours_newInstalls * this.storagehourly;
    this.totalAdminCosts =
      this.costsSuppTickets +
      this.costsPlanningEval +
      this.costsMonitoring +
      this.costsAppOptimization +
      this.costsSecurityCompliance +
      this.costsUserAccess +
      this.costsDataProtection +
      this.costsNewInstalls;

    this.costsSuppTicketsIBM = this.IThrsYearIBM * this.storagehourly;
    this.costsPlanningEvalIBM = this.hours_planningEvalIBM * this.storagehourly;
    this.costsMonitoringIBM = this.hours_monitoringIBM * this.storagehourly;
    this.costsAppOptimizationIBM =
      this.hours_applicationOptimizationIBM * this.storagehourly;
    this.costsSecurityComplianceIBM =
      this.hours_SecurityCompIBM * this.storagehourly;
    this.costsUserAccessIBM = this.hours_userAccessIBM * this.storagehourly;
    this.costsDataProtectionIBM =
      this.hours_dataProtectionIBM * this.storagehourly;
    this.costsNewInstallsIBM = this.hours_newInstallsIBM * this.storagehourly;
    this.totalAdminCostsIBM =
      this.costsSuppTicketsIBM +
      this.costsPlanningEvalIBM +
      this.costsMonitoringIBM +
      this.costsAppOptimizationIBM +
      this.costsSecurityComplianceIBM +
      this.costsUserAccessIBM +
      this.costsDataProtectionIBM +
      this.costsNewInstallsIBM;

    this.totalAdminPCT =
      ((this.totalAdminCosts - this.totalAdminCostsIBM) /
        this.totalAdminCosts) *
      100;

    this.totalAdminSavings = this.totalAdminCosts - this.totalAdminCostsIBM;
  };

  get expectedAnnualCost() {
    return {
      costsSuppTickets: ROUND(this.costsSuppTickets),
      costsPlanningEval: ROUND(this.costsPlanningEval),
      costsMonitoring: ROUND(this.costsMonitoring),
      costsAppOptimization: ROUND(this.costsAppOptimization),
      costsSecurityCompliance: ROUND(this.costsSecurityCompliance),
      costsUserAccess: ROUND(this.costsUserAccess),
      costsDataProtection: ROUND(this.costsDataProtection),
      costsNewInstalls: ROUND(this.costsNewInstalls),
    };
  }

  get expectedAnnualCostIBM() {
    return {
      costsSuppTicketsIBM: ROUND(this.costsSuppTicketsIBM),
      costsPlanningEvalIBM: ROUND(this.costsPlanningEvalIBM),
      costsMonitoringIBM: ROUND(this.costsMonitoringIBM),
      costsAppOptimizationIBM: ROUND(this.costsAppOptimizationIBM),
      costsSecurityComplianceIBM: ROUND(this.costsSecurityComplianceIBM),
      costsUserAccessIBM: ROUND(this.costsUserAccessIBM),
      costsDataProtectionIBM: ROUND(this.costsDataProtectionIBM),
      costsNewInstallsIBM: ROUND(this.costsNewInstallsIBM),
    };
  }

  get adminCost() {
    return {
      totalAdminCosts: ROUND(this.totalAdminCosts),
      totalAdminSavings: ROUND(this.totalAdminSavings),
      totalAdminCostsIBM: ROUND(this.totalAdminCostsIBM),
      totalAdminPCT: ROUND(this.totalAdminPCT),
    };
  }
}
